import Vue from 'vue'

import httpManager from '../../util/common'
import {dealNewsTypeLists} from "../../util/util";
import LimitMask from '../../common/components/mask.vue'



let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      loading: false,
      exportConfig: {},
      data: [],
      page: {
        pagenum: 1,
        pagesize: 10,
        total: 0,
        pagerCount:3,
        perfect: true,
        layouts: ['PrevPage', 'Number', 'NextPage'],
      },
      showMask: false
    }
  },
 methods: {
    cardClick (oaid) {
      const {
        href
      } = this.$router.resolve({path: '/entity/' + oaid + '/home'})
      window.open(href, '_blank')
    },
    onChange ({ currentPage }) {
      this.page.pagenum = currentPage
      this.getData()
    },
    getData() {
      let self = this
      let params = new Map()
      params.set('pagenum', this.page.pagenum)
      params.set('pagesize', this.page.pagesize)
      httpManager("follow_entities", params)
        .then(response => {
          self.data = response.data.data
          self.page.total = response.data.page.total
        })
        .catch(error => {
          if (this.$route.path === '/home' && error.response.status === 403) {
            this.showMask = true
          }
          console.log(error)
          self.loading = false
        })
    },

  },
  mounted() {
    this.getData()
  },

  watch: {}
}
Vue.component("follow-board", vm)
export default vm



// WEBPACK FOOTER //
// ./src/home/js/entity_follow.js